export default __webpack_public_path__ + "static/media/nointernet.d2908649.svg";